import { Component, type ErrorInfo, type ReactNode } from "react"
import { AlertTriangle } from "lucide-react"
import { Button } from "@/components/ui/button"

interface ErrorBoundaryProps {
	children: ReactNode
}

interface ErrorBoundaryState {
	hasError: boolean
}

/**
 * Captura errores de render en el árbol hijo y ofrece refrescar la página
 * en lugar de dejar la app en blanco.
 */
export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	override state: ErrorBoundaryState = { hasError: false }

	static getDerivedStateFromError(): ErrorBoundaryState {
		return { hasError: true }
	}

	override componentDidCatch(error: Error, info: ErrorInfo): void {
		console.error("ErrorBoundary:", error, info.componentStack)
	}

	handleRefresh = (): void => {
		window.location.reload()
	}

	override render(): ReactNode {
		if (this.state.hasError) {
			return (
				<div className="flex min-h-[50vh] flex-col items-center justify-center px-4 py-16 text-center">
					<AlertTriangle className="h-12 w-12 text-destructive" aria-hidden />
					<h1 className="mt-4 text-2xl font-bold">Algo salió mal</h1>
					<p className="mt-2 max-w-md text-muted-foreground">
						Ocurrió un error inesperado. Puedes intentar refrescar la página.
					</p>
					<Button className="mt-6" onClick={this.handleRefresh}>
						Refrescar página
					</Button>
				</div>
			)
		}

		return this.props.children
	}
}
